import styled from 'styled-components';

export const ContainerDetailText = styled.div`
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  width: 100%;
  div {
    &:nth-child(2) {
      margin-top: 20px;
    }
  }
`;
